var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#2a2a2a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_418",
    "data-name": "Mask Group 418",
    transform: "translate(-479 -1208)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_14_",
    "data-name": "svgexport-6 (14)",
    transform: "translate(479 1208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5160",
    "data-name": "Group 5160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9732",
    "data-name": "Path 9732",
    d: "M7,6.87A2.691,2.691,0,0,0,9.4,3.96c0-1.607-.352-2.91-2.4-2.91s-2.4,1.3-2.4,2.91A2.691,2.691,0,0,0,7,6.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9733",
    "data-name": "Path 9733",
    d: "M11.52,11.2c-.044-2.8-.41-3.6-3.208-4.1A1.678,1.678,0,0,1,7,7.6a1.677,1.677,0,0,1-1.312-.5c-2.768.5-3.155,1.285-3.206,4.011,0,.223-.006.234-.007.208,0,.048,0,.138,0,.294,0,0,.666,1.343,4.525,1.343s4.525-1.343,4.525-1.343c0-.1,0-.17,0-.218A1.759,1.759,0,0,1,11.52,11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9734",
    "data-name": "Path 9734",
    d: "M10.325,6.35a2.185,2.185,0,0,0,1.946-2.363c0-1.305-.286-2.363-1.946-2.363A2.774,2.774,0,0,0,9.6,1.71a4.77,4.77,0,0,1,.436,2.25,3.99,3.99,0,0,1-.6,2.13A1.667,1.667,0,0,0,10.325,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9735",
    "data-name": "Path 9735",
    d: "M14,9.864c-.036-2.274-.333-2.922-2.606-3.332a1.362,1.362,0,0,1-1.066.408l-.09,0a2.99,2.99,0,0,1,1.222.946,5.556,5.556,0,0,1,.7,3.248C13.687,10.829,14,10.2,14,10.2c0-.082,0-.139,0-.177A1.345,1.345,0,0,1,14,9.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9736",
    "data-name": "Path 9736",
    d: "M3.675,6.35a1.667,1.667,0,0,0,.888-.261,3.99,3.99,0,0,1-.6-2.13A4.771,4.771,0,0,1,4.4,1.71a2.774,2.774,0,0,0-.726-.086c-1.66,0-1.946,1.058-1.946,2.363A2.185,2.185,0,0,0,3.675,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9737",
    "data-name": "Path 9737",
    d: "M3.765,6.937l-.09,0A1.362,1.362,0,0,1,2.61,6.532C.337,6.942.04,7.59,0,9.864a1.38,1.38,0,0,1,0,.157c0,.039,0,.095,0,.177,0,0,.313.631,1.842.933a5.557,5.557,0,0,1,.7-3.248A2.989,2.989,0,0,1,3.765,6.937Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.a25a078ac1acbbf134147227fe76a754.svg";
export { ForwardRef as ReactComponent };